import { render } from "./FieldNumber.vue?vue&type=template&id=4cff6a5d&ts=true"
import script from "./FieldNumber.vue?vue&type=script&lang=ts"
export * from "./FieldNumber.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__